import { Component, Input, OnInit } from '@angular/core';
import { ButtonClassesEnum, IButtonModel, IconClassesEnum } from '@types-custom/models/ui/button-model';
import { AbstractControl, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Co2Service } from '@shared/services/layer-service/co2-service/co2.service';
import { GeoApiService } from '@shared/services/geo-api-service/geo-api.service';
import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { MapboxDataService } from '@sdk/services/map-box-data/mapbox-data.service';
import { GeometryTypeEnum, MarkerModelBase } from '@types-custom/models/business/marker.model';

@Component({
  selector: 'cdm-manizales-filter-air-quality',
  templateUrl: './filter-air-quality.component.html',
  styleUrls: ['./filter-air-quality.component.scss'],
})
export class FilterAirQualityComponent implements OnInit {

  @Input() properties: any;


  filter: any[] = [];

  formgroup: UntypedFormGroup;
  Icon = Icon;
  options: any[];
  filteredOptions: Observable<any[]>;
  fb = new UntypedFormBuilder();
  showConventions!: boolean;
  typeStationt = new FormControl('');

  SensorsGroupTypes: any[] = [
    {
      name: "Estaciones",
      value: 'STATION'
    },
    {
      name: "Mini estaciones",
      value: 'MINI_STATION'
    }
  ];

  indicators: any[] = []

  constructor(serviceCo2: Co2Service,
    private geoApiService: GeoApiService,
  ) {
    serviceCo2.getStationIndicators().subscribe((res: any) => {
      this.indicators = res.map((elem: any) => { return { id: elem.code, value: elem.name } })
    })
  }

  ngOnInit(): void {
    this.initializeForm()

  }

  private initializeForm(): void {
    // this.formgroup.addControl(
    //   'indicator', this.indicatorControl
    // ):

    const formControls: { [key: string]: any } = {
      typeStation: [
        { value: '', disabled: false },
      ],
      indicator: [
        { value: null, disabled: false },
      ]
    };

    this.formgroup = this.fb.group(formControls);
  }

  public resetFilter() {
    const filter: string[] = [];
    this.filter = [];
    this.properties.mapFilterDispatcher$.next({ filter: filter });
  }

  public selectedCheck(control: AbstractControl, item: any): boolean {
    return control.value.includes(item.value);
  }

  public updateSelection(control: AbstractControl, event: any, item: any) {
    const selectedItemsControl = control;
    let selectedItems = selectedItemsControl?.value || [];

    if (event.target.checked) {
      if (item.value === -1) {
        selectedItems = [-1]
      }
      else {
        selectedItems = selectedItems.filter((e: any) => e != -1);
        selectedItems.push(item.value);
      }
    } else {
      const index = selectedItems.indexOf(item.value);
      if (index > -1) {
        selectedItems.splice(index, 1);
      }
    }
    selectedItemsControl?.setValue(selectedItems, { emitEvent: false });
  }

  OnFilter() {
    let result: any

    if (this.formgroup.value) {
      result = [{
        indicator: this.formgroup.get('indicator').value ? this.formgroup.get('indicator').value : '' ,
        typeStation: this.formgroup.get('typeStation').value
      }]
    }

    this.geoApiService.getAirQualityPoints(GeoAPITypeEnum.ResourcesAirQualityPoints, true, result).subscribe({
      next: this.reloadData.bind(this)
    });

  }
  reloadData(response: any) {

    const points = {
      type: GeometryTypeEnum.Point,
      markers: [] as unknown as MarkerModelBase[],
      dataFeatures: [] as Array<any>,
    };
    const heatMapLayer = response;

    heatMapLayer.forEach((mark: any) => {
      const feature = {
        properties: (mark as any).classProperties,
        geometry: {
          type: (mark as any).geometry.type,
          coordinates: (mark as any).geometry.coordinates,
        },
        type: 'Feature',

      };
      points.markers.push(mark);
      points.dataFeatures.push(feature as never);
    });

    this.properties.mapFilterDispatcher$.next({
      layer: this.properties.layer,
      filter: undefined,
      source: points.dataFeatures,
      visibility: true
    });
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();
    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.add('applied-filter');
      // Remover marker seleccionado
      document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }
}
